module.exports = __webpack_public_path__ + "img/prom.d913816c.svg";